import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { StorageService } from '../services/storage.service';

@Injectable()
export class AppUrl {
  static get USER_URL(): string {
    return environment.appUrl + 'user/';
  }

  static get LOGIN(): string {
    return AppUrl.USER_URL + 'login';
  }

  static QUESTION_TYPE(): string {
    return AppUrl.USER_URL + 'paper-type';
  }

  static ADD_QUESTIONS(uniqueId: string): string {
    return AppUrl.USER_URL + 'schedule-subject/'+uniqueId;
  }

  static get SELF(): string {
    return AppUrl.USER_URL + 'self';
  }

  static UPDATE_PASSWORD(): string {
    return AppUrl.USER_URL + 'update-password';
  }

  static UPDATE_SELF(): string {
    return AppUrl.USER_URL + 'update-self';
  }

  static LOGOUT(): string {
    return AppUrl.USER_URL + 'logout';
  }

  static UPDATE_PROFILE_IMAGE(): string {
    return AppUrl.USER_URL + 'update-profile-image';
  }

  static FILE_UPLOAD(): string {
    return AppUrl.USER_URL + 'file-upload';
  }

  static MULTIPLE_FILE_UPLOAD(): string {
    return AppUrl.USER_URL + 'file-multiple-upload';
  }

  static COUNTRY(): string {
    return AppUrl.USER_URL + 'countries';
  }

  static USERS(): string {
    return AppUrl.USER_URL + 'user';
  }

  static SESSION_LIST(): string {
    return AppUrl.USER_URL + 'session-list';
  }

  static STATES(uniqueId?: any): string {
    if (uniqueId) return AppUrl.USER_URL + 'states/' + uniqueId;
    else return AppUrl.USER_URL + 'states';
  }

  static COORDINATOR(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.USER_URL + 'coordinator/' + uniqueId;
    } else {
      return AppUrl.USER_URL + 'coordinator';
    }
  }

  static COORDINATOR_STATUS(unique_id: any): string {
    return AppUrl.USER_URL + 'coordinator-status/' + unique_id;
  }

  static COORDINATOR_CHANGE_PASSWORD(unique_id: any): string {
    return AppUrl.USER_URL + 'update-coordinator-password/' + unique_id;
  }

  static ASSIGNED_SUBJECT_LIST_STUDENT(userId: any): string {
    return AppUrl.USER_URL + 'student-subject-list/' + userId;
  }

  static ASSIGN_SUBJECT_STUDENT(userId: any): string {
    return AppUrl.USER_URL + 'student-assign-subject/' + userId;
  }

  static DELETE_QUESTIONS(uniqueId: any): string {
    return AppUrl.USER_URL + 'subject-delete-question/' + uniqueId;
  }

  static QUESTION_UPLOAD_COMPLETE(uniqueId: any): string {
    return AppUrl.USER_URL + 'subject-question-status/' + uniqueId;
  }

  static SESSION(uniqueId?: any): string {
    if (uniqueId) return AppUrl.USER_URL + 'session/' + uniqueId;
    else return AppUrl.USER_URL + 'session';
  }

  static DEFAULT_SESSION(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.USER_URL + 'session-default/' + uniqueId;
    } else {
      return AppUrl.USER_URL + 'session-default';
    }
  }

  static STUDENT_PHOTO(): string {
    return AppUrl.USER_URL + 'student-profile-upload';
  }

  static STUDENT_PHOTO_ID_UPDATE(uniqueId: any): string {
    return AppUrl.USER_URL + 'student-profile-update/'+uniqueId;
  }

  static STUDENT_STATUS(uniqueId: any): string {
    return AppUrl.USER_URL + 'student-status/' + uniqueId;
  }

  static SESSION_STATUS(uniqueId: any, status: any): string {
    if (status == 'default_session')
      return AppUrl.USER_URL + 'default-session';
    else if (status == 're-registration-session')
      return AppUrl.USER_URL + 're-registration-session/' + uniqueId;
    else if (status == 're-registration-entry-session')
      return AppUrl.USER_URL + 're-registration-entry-session/' + uniqueId;
    else if (status == 'admission-session')
      return AppUrl.USER_URL + 'admission-session/' + uniqueId;
    else if (status == 're-opened-session')
      return AppUrl.USER_URL + 're-opened-session/' + uniqueId;
    else return AppUrl.USER_URL + 'session-status/' + uniqueId;
  }

  static SUBJECT(uniqueId?: any): string {
    if (uniqueId) return AppUrl.USER_URL + 'subject/' + uniqueId;
    else return AppUrl.USER_URL + 'subject';
  }

  static SUBJECT_STATUS(uniqueId: any): string {
    return AppUrl.USER_URL + 'subject-status/' + uniqueId;
  }

  static STUDENT(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.USER_URL + 'student/' + uniqueId;
    } else {
      return AppUrl.USER_URL + 'student';
    }
  }

  static STUDENT_COUNT(): string {
    return AppUrl.USER_URL + 'student-count';
  }

  static UPCOMING_EXAM(): string {
    return AppUrl.USER_URL + 'upcoming-subject';
  }

  static LIVE_EXAM(): string {
    return AppUrl.USER_URL + 'ongoing-subject';
  }

  static MONITORED_EXAM(): string {
    return AppUrl.USER_URL + 'monitored-subject';
  }

  static ASSIGNED_INVIGILATORS(): string {
    return AppUrl.USER_URL + 'assigned-list';
  }

  static CURRENT_TIME(): string {
    return AppUrl.USER_URL + 'current-time';
  }

  static FLAGGED_STUDENTS(subjectId: any): string {
    return AppUrl.USER_URL + 'flagged-student-list/' + subjectId;
  }

  static SENT_NOTIFICATION_INVIGILATOR(): string {
    return AppUrl.USER_URL + 'invigilator-notification-list';
  }

  static STUDENT_RECORDINGS(): string {
    return AppUrl.USER_URL + 'flagged-student-videos';
  }

  static SEND_TO_STUDENT(): string {
    return AppUrl.USER_URL + 'student-notification';
  }

  static STUDENT_EXAM_STATUS(): string {
    return AppUrl.USER_URL + 'remarks-student-notification';
  }

  static AI_NOTIFICATION(): string {
    return AppUrl.USER_URL + 'student-notification-list';
  }

  static CHEAT_NOTIFICATION_MARK_READ(): string {
    return AppUrl.USER_URL + 'read-notification';
  }

  static STUDENTS_SUBMITTED_PAPER(): string {
    return AppUrl.USER_URL + 'exam-completed-student';
  }

  static SUBJECT_LIST(): string {
    return AppUrl.USER_URL + 'subject-list';
  }

  static ASSIGNED_SUBJECTS_EVALUATOR(): string {
    return AppUrl.USER_URL + 'evaluator-assigned-subject';
  }

  static SUBMITTED_ANSWERS(): string {
    return AppUrl.USER_URL + 'evaluate-exam';
  }

  static SUBMIT_MARKS(): string {
    return AppUrl.USER_URL + 'evaluate-subjective';
  }

  static EVALUATORS_LIST(): string {
    return AppUrl.USER_URL + 'evaluator-assigned-list';
  }

  static GENERATE_RESULT(): string {
    return AppUrl.USER_URL + 'generate-exam-result';
  }

  static RESULT(): string {
    return AppUrl.USER_URL + 'exam-results';
  }

  static EVALUATORS_SUBJECT_LIST(id: any): string {
    return AppUrl.USER_URL + 'evaluator-subject-list/' + id;
  }

  static DECLARE_RESULT(): string {
    return AppUrl.USER_URL + 'declare-exam-result';
  }

  static ASSIGN_SUBJECTS_EVALUATOR(id: any): string {
    return AppUrl.USER_URL + 'evaluator-assign-subject/' + id;
  }

  static COORDINATOR_LIST(): string {
    return AppUrl.USER_URL + 'coordinator-list';
  }

  static SUBJECT_LIST_FOR_MAPPING(): string {
    return AppUrl.USER_URL + 'student-assigned-list';
  }

  static UPLOAD_INSTRUCTIONS(): string {
    return AppUrl.USER_URL + 'instruction-upload';
  }

  static UPDATE_INSTRUCTION_ID(id: any): string {
    return AppUrl.USER_URL + 'instruction-update/'+id;
  }

  static UPLOAD_QUESTION_IMAGE(): string {
    return AppUrl.USER_URL + 'question-image-upload';
  }

  static UPDATE_QUESTION_IMAGE_ID(): string {
    return AppUrl.USER_URL + 'question-image-update';
  }

  static ASSIGN_INVIGILATOR(): string {
    return AppUrl.USER_URL + 'invigilator-assign-student';
  }

  static ASSIGN_EVALUATOR(): string {
    return AppUrl.USER_URL + 'evaluator-assign-student';
  }

  static QUESTIONS_TO_ATTEMPT(id: any): string {
    return AppUrl.USER_URL + 'update-question-attempt/'+id;
  }

  static STUDENTS_IN_EXAM(): string {
    return AppUrl.USER_URL + 'exam-attended-student';
  }

  static SEND_GENERAL_NOTIFICATION(): string {
    return AppUrl.USER_URL + 'session-notification';
  }

  static GENERAL_NOTIFICATION_MARK_READ(): string {
    return AppUrl.USER_URL + 'read-notification-generic';
  }

  static GENERAL_NOTIFICATION_LIST(): string {
    return AppUrl.USER_URL + 'general-notification-list';
  }

  static SENT_NOTIFICATION_BY_ORG(): string {
    return AppUrl.USER_URL + 'organisation-notification-list';
  }

  static SUPPORT_TICKET(id?: any): string {
    if (id) return AppUrl.USER_URL + 'support-ticket/'+id;
    else return AppUrl.USER_URL + 'support-ticket';
  }

  static SUPPORT_TICKET_STATUS(id: any): string {
    return AppUrl.USER_URL + 'support-ticket-status/'+id;
  }

  static DASHBOARD(): string {
    return AppUrl.USER_URL + 'dashboard';
  }

  static INVIGILATOR_LOGS(id: any): string {
    return AppUrl.USER_URL + 'invigilator-log/'+id;
  }

  static UPLOAD_PHOTO_ZIP(): string {
    return AppUrl.USER_URL + 'upload-zip';
  }

  static EVALUATORS_WITH_RANGE(): string {
    return AppUrl.USER_URL + 'evaluator-assigned-range';
  }

  static INVIGILATORS_WITH_RANGE(): string {
    return AppUrl.USER_URL + 'invigilator-assigned-range';
  }
}
